export default __webpack_public_path__ + "static/media/ic_fb_share.68c21de3.svg";